/**
 * Базы 1С и выбранная из них.
 *
 * Выбор запоминается в браузере и уходит в каждом запросе заголовком
 * X-Source-Id. Если запомненной базы больше нет, выбирается первая из списка.
 */

import { create } from "zustand";

import { api, getSourceId, setSourceId } from "../api/client";
import type { SourceOut } from "../api/types";

interface SourcesState {
  sources: SourceOut[];
  currentId: string | null;
  loaded: boolean;
  load: () => Promise<SourceOut[]>;
  select: (id: string | null) => void;
  forget: () => void;
}

export const useSources = create<SourcesState>((set, get) => ({
  sources: [],
  currentId: getSourceId(),
  loaded: false,

  async load() {
    const sources = await api.get<SourceOut[]>("/sources");
    const current = get().currentId;
    const keep = sources.some((source) => source.id === current);
    const next = keep ? current : (sources[0]?.id ?? null);
    if (next !== current) setSourceId(next);
    set({ sources, currentId: next, loaded: true });
    return sources;
  },

  select(id) {
    setSourceId(id);
    set({ currentId: id });
  },

  forget() {
    set({ sources: [], loaded: false });
  },
}));

export const selectCurrentSource = (state: SourcesState): SourceOut | null =>
  state.sources.find((source) => source.id === state.currentId) ?? null;
